import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'keyOrderPropertyUpdateInProgress',
  initialState: false,
  reducers: {
    setKeyOrderPropertyUpdateInProgress(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setKeyOrderPropertyUpdateInProgress } = slice.actions;

export default slice.reducer;
